import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	workItemLabel: {
		id: 'jira-dc.work-item.label',
		defaultMessage: 'Work item',
		description: 'Work item label',
	},
	issueLabel: {
		id: 'jira-dc.work-item-task.issue',
		defaultMessage: 'Issue',
		description: 'Issue label',
	},
	for: {
		id: 'jira-dc.work-item-status.for',
		defaultMessage: '{statusLozenge} for {dateLozenge}',
		description: 'The conjunction between a status and date e.g. "On track for August"',
	},
	isAssigned: {
		id: 'jira-dc.work-item-assignee.assigned',
		defaultMessage:
			'{isAssigned, select, internal {{firstName} is assigned} other {External person is assigned}}',
		description: 'Text that goes after assignee name',
	},
	created: {
		id: 'jira-dc.work-item-creator.created',
		defaultMessage:
			'{created, select, internal {{firstName} created} other {External person created}}',
		description: 'Text that goes after creator name',
	},
});
